import { useMemo } from "react";
import useWindowSize from "./useWindowSize";

export default function useAdColSpanSize() {
  const { windowWidth } = useWindowSize();

  const adColSpanSize = useMemo(() => {
    if (windowWidth && windowWidth < 875) {
      return 2;
    }
    return 4;
  }, [windowWidth]);

  return adColSpanSize;
}
